import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import {
    convertChestRewardListFromStrings,
    convertChestRewardListToStrings,
    useMixins
} from '@/modules/picword/map/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';

export function usePicwordMapEdit() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { v$, model, addChestReward, removeChestReward, clearChestForm } = useMixins();

    const fetch = crudAction.executeAction({
        request: () => picwordService.map.get(model.id),
        onSuccess: ({ data }) => {
            model.chestRewardList = convertChestRewardListFromStrings(
                data.chestByStar,
                data.chestRewardCredit,
                data.chestRewardHeart,
                data.chestRewardBooster
            );
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PICWORD.MAP.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const chests = convertChestRewardListToStrings(model.chestRewardList);
                return picwordService.map.update(
                    model.id,
                    model.name,
                    chests.chestByStars,
                    chests.chestRewardCredits,
                    chests.chestRewardHearts,
                    chests.chestRewardBoosters
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.MAP.INDEX })
        }),
        addChestReward,
        removeChestReward,
        clearChestForm
    };

    return { model, v$, fetch, actions };
}
